export const showDock = (name, proposal, email) => async (dispatch, getState) => {
    name = getState().docks.active === name ? null : name;
    dispatch({type: 'SHOW_DOCK', name, proposal: proposal ? proposal : null, email: email});
};

export const reloadDock = (name) => async (dispatch, getState) => {
    dispatch({type: 'RELOAD_DOCK'});
};